import React from "react";
import { Paper, Typography, Box, Stack, Divider, Tooltip } from "@mui/material";
import { Terrain, Info } from "@mui/icons-material";
import { calculateAkkClass } from "../../utils/akkUtils";

export default function AkkFormulaCard({ formData }) {
  // Artık tüm hesaplamaları, payı, paydayı ve tam formülü tek satırda utils'ten hazır çekiyoruz!
  const {
    finalClass,
    subClassString,
    limitingFactor,
    penaltyValue,
    alternateClass,
    numerator,
    denominator,
    sideFactors,
    fullFormulaString,
  } = calculateAkkClass(formData);

  return (
    <Paper
      elevation={3}
      sx={{
        p: 2,
        borderRadius: 2,
        bgcolor: "#fff8e1",
        border: "1px solid #ffecb3",
        height: "100%",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Stack direction="row" alignItems="center" spacing={1} mb={2}>
        <Terrain color="warning" />
        <Typography variant="h6" fontWeight="bold" color="text.primary">
          AKK Formülü
        </Typography>
        {/* AKK sinifi formulun icinde degil, basligin yaninda gosterilir:
            referansta formulun basindaki konum yalnizca profil grubu (V)
            icindir ve o da sadece indeks calismasinda gecerlidir. */}
        <Typography
          variant="subtitle1"
          fontWeight="900"
          color="error.main"
          sx={{ lineHeight: 1 }}
        >
          {finalClass}
          {subClassString}
        </Typography>
        <Tooltip title="AKK.doc Standart Semboller formatına göre hesaplanmıştır.">
          <Info fontSize="small" color="disabled" sx={{ cursor: "help" }} />
        </Tooltip>
      </Stack>

      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexGrow: 1,
          py: 4,
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            mx: 2,
            position: "relative",
          }}
        >
          <Typography
            variant="h5"
            fontFamily="monospace"
            fontWeight="bold"
            color="#333"
            sx={{ letterSpacing: 2 }}
          >
            {numerator}
          </Typography>
          <Divider
            sx={{
              width: "100%",
              minWidth: "60px",
              borderBottomWidth: 3,
              borderColor: "#000",
              my: 0.5,
            }}
          />
          <Typography
            variant="h5"
            fontFamily="monospace"
            fontWeight="bold"
            color="#333"
            sx={{ letterSpacing: 2 }}
          >
            {denominator}
          </Typography>

          <Box
            sx={{
              position: "absolute",
              top: "100%",
              mt: 1.5,
              display: "flex",
              alignItems: "baseline",
              gap: 0.5,
              bgcolor: "rgba(255, 255, 255, 0.7)",
              px: 2,
              py: 0.5,
              borderRadius: 2,
              border: "1px dashed #ffb300",
              whiteSpace: "nowrap",
            }}
          >
          </Box>
        </Box>

        {sideFactors && (
          <Box sx={{ ml: 1 }}>
            <Typography
              variant="h5"
              fontFamily="monospace"
              color="text.primary"
              fontWeight="bold"
              sx={{ letterSpacing: 1 }}
            >
              {sideFactors}
            </Typography>
          </Box>
        )}
      </Box>

      {/* FAKTÖR UYARI KUTUSU */}
      {penaltyValue > 0 && (
        <Box
          sx={{
            mt: 2,
            p: 1.5,
            bgcolor: "#ffebee",
            borderRadius: 2,
            border: "1px dashed #ef9a9a",
            textAlign: "center",
          }}
        >
          <Typography
            variant="caption"
            display="block"
            color="error.main"
            fontWeight="bold"
          >
            ⚠️ AKK SINIFINI DÜŞÜREN ANA FAKTÖR: {limitingFactor.toUpperCase()}{" "}
            (+{penaltyValue} Sınıf)
          </Typography>
          <Typography
            variant="body2"
            color="text.secondary"
            fontWeight="bold"
            sx={{ mt: 0.5 }}
          >
            Eğer bu sorun olmasaydı arazi sınıfı{" "}
            <span style={{ color: "#2e7d32", fontSize: "1.1rem" }}>
              {alternateClass}
            </span>{" "}
            olacaktı.
          </Typography>
        </Box>
      )}

      {/* FOOTER */}
      <Box
        sx={{
          mt: 2,
          p: 2,
          bgcolor: "rgba(0,0,0,0.05)",
          borderRadius: 1,
          textAlign: "center",
        }}
      >
        <Typography
          variant="caption"
          color="text.secondary"
          fontWeight="bold"
          display="block"
        >
          TAM FORMÜL STRİNGİ:
        </Typography>
        <Typography
          variant="body1"
          fontFamily="monospace"
          sx={{ wordBreak: "break-all", fontWeight: "bold" }}
        >
          {fullFormulaString}
        </Typography>
      </Box>
    </Paper>
  );
}
